<template>
    <div class="index-img-bottom">
        <img src="@/assets/Image/index-img-05.png" class="index-img" />   
        <div class="bottom-btn-box">
            <img src="@/assets/Image/index-img-05-01.png"  @click="gongshangFun" class="bottom-btn-img" />  
            <img src="@/assets/Image/index-img-05-02.png"  @click="beianchaxunFun" class="bottom-btn-img" />  
        </div>                 
    </div>
</template>

<script>
export default {
    name: "aboutUs",
    data() {
        return { }
    },
    methods:{
        beianchaxunFun(){
            window.location.href = 'https://beian.miit.gov.cn/'
        },
        gongshangFun(){
            window.location.href = 'https://www.gsxt.gov.cn/'
        }
    }
};
</script>

<style lang="less" scoped>
.index-img-bottom{ 
    width: 100%;    
    position: relative; 
    .index-img{
        width: 100%;
        display: block;
    }    
    .bottom-btn-box{
        width: 100%;
        position: absolute;
        bottom: 16px;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .bottom-btn-img{
            width: 98px;
            display: block;
        }   
        .bottom-btn-img:first-child{
            margin-right: 40px;
        }   
    }   
} 
</style>
